export default "__VITE_ASSET__D422yK57__"